import React, { useEffect, useState } from 'react';
import { sectionHeaderStyle } from './styles';
import { ServiceRegistry } from '../../../../core/ServiceRegistry';

interface NetworkStatsProps {
  isConnected: boolean;
}

export const NetworkStats: React.FC<NetworkStatsProps> = ({ isConnected }) => {
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    const tick = () => {
      const manager = ServiceRegistry.getInstance().get('NetworkManager');
      setStats(manager?.getDiagnostics() || null);
    };
    tick();
    const id = setInterval(tick, 500);
    return () => clearInterval(id);
  }, []);

  if (!isConnected) return null;

  return (
    <>
      <div style={sectionHeaderStyle}>Network Stats</div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
        padding: '10px',
        background: 'rgba(0,0,0,0.2)',
        borderRadius: '4px',
        fontSize: '11px'
      }}>
        <div>Latency: <span style={{ color: (stats?.ping ?? 999) < 100 ? '#2ecc71' : '#e67e22' }}>{stats?.ping ?? '--'}ms</span></div>
        <div>Avg Ping: <span style={{ color: '#2ecc71' }}>{stats?.avgPing ?? '--'}ms</span></div>
        <div>Throughput: <span style={{ color: '#aaa' }}>{stats?.throughput ?? 0}/s</span></div>
        <div>Room UUID: <span style={{ color: '#aaa' }}>{stats?.roomInstanceId || 'pending'}</span></div>
      </div>
    </>
  );
};
